/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneFrontCoverstory as ResolvedStandaloneFrontCoverstory } from 'base/components/standalone/FrontCoverstory';

export const FrontCoverstory: typeof ResolvedStandaloneFrontCoverstory = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneFrontCoverstory {...props} />
        </ErrorBoundary>
    );
});

export type FrontCoverstoryProps = PropsFromComponent<typeof FrontCoverstory>;

/** @deprecated Use slot architecture instead */
export const FrontCoverstoryWith = (extras: DynamicStandaloneExtras): typeof FrontCoverstory => {
    return function FrontCoverstory(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'FrontCoverstory');
        return <ResolvedStandaloneFrontCoverstory {...mergeProps({ options: { theme } }, props)} />;
    }
}